export const JSON_VIEWER_THEME = 'twilight';
